import { render, staticRenderFns } from "./ManageRoles.vue?vue&type=template&id=0dd32f2e&"
import script from "./ManageRoles.vue?vue&type=script&lang=js&"
export * from "./ManageRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports